export default {
    namespaced: true,
    users: {
        title: "Usuário | Usuários",
        email: "correio eletrônico",
        name: "nome",
        username : "nome de usuário",
        first_name: "primeiro sobrenome",
        second_name: "segundo sobrenome",
        last_name: "sobrenome",
        password: "senha",
        phone_number: "número de telefone",
        active: "ativo",
        vpn_access: "acesso vpn",
        last_login: "último login",
        alarms_history: "histórico de alarme",
        allowed_units_live_video_flows: "fluxos de vídeo permitidos",
        alarm_history_per_hours: "horas permitidas de histórico de alarme",
        alarm_history_per_days: "dias permitidos de histórico de alarme",
        alarm_history_by_records: "registros de histórico de alarme permitidos",
        plate_number: "no. da placa o no. de funcionário",
        allowed_tabs: "abas permitidas",
        shared_tenants: "tenants compartilhados",
        video_wall: "video wall",
        info: "info",
        saving_info: "guardando as informações do usuário",
        enabled_chat: "bate-papo ativado",
        enabled_helpdesk: "helpdesk ativado",
        id_country: "identificação do país",
        set_password: {
            title: "configurar senha",
            password: "digite a senha",
            password_retype: "confirme a senha",
            password_rules: "Digite sua nova senha para ter acesso à plataforma SBO. Lembre-se de que deve ter pelo menos 8 caracteres, sendo uma letra maiúscula, uma letra minúscula, um número e um caractere especial."
        },
        expired_link: "Link expirado",
        generate_link: "Gerar link",
        send_link_email: "Enviar link por e-mail",
        reset_password: "Redefinir senha",
        belogs_user: "O usuário pertence ao grupo ",
        reset_password_no_email: "Configurar senha",
        search_leader: "Pesquisar líder...",
        search_users: "Pesquisar usuários...",
        search_filters: {
            soeid: "SOEID",
            email: "E-mail",
            name: "Nome",
            first_name: "Sobrenome paterno",
            second_name: "Sobrenome materno",
            phone_number: "Número de telefone",
        },
        user_exists: "Este nome de usuário já está registrado.",
        email_exists: "Este endereço de e-mail já está registrado.",
    },
};
